module.exports = __webpack_public_path__ + "static/media/vnr1.8d9a0ca7.png";